module.exports = __webpack_public_path__ + "static/media/play-more-capture.544167f0.ogg";